import { useState } from 'react';
import { AdminCatalogProductImage } from '../../../api/types';
import { CatalogPhoto } from './CatalogPhoto';

export function CatalogPhotoGallery({ images, name }: { images: AdminCatalogProductImage[]; name: string }) {
  const [selectedId, setSelectedId] = useState<number>();
  const visibleImages = images.filter((image) => image.link_image_is_published !== false);
  const selected = visibleImages.find((image) => image.link_file_id === selectedId) ?? visibleImages[0];
  return (
    <div className="catalog-photo-gallery">
      <div className="catalog-photo-stage"><CatalogPhoto fileId={selected?.link_file_id} image={selected?.image} name={name} /></div>
      {visibleImages.length > 1 ? (
        <div className="catalog-photo-thumbnails" aria-label="Фотографии товара">
          {visibleImages.map((image, index) => <button type="button" key={image.link_id} aria-pressed={selected?.link_id === image.link_id} aria-label={`Фотография ${index + 1}`} onClick={() => setSelectedId(image.link_file_id)}><CatalogPhoto fileId={image.link_file_id} image={image.image} sizes="48px" name="" /></button>)}
        </div>
      ) : null}
    </div>
  );
}
